export default "__VITE_ASSET__CHsDWPaq__"